/**
 * Which copy a unit's artwork escalation shows (phase 50.1; Phase 92 adds the
 * supply branch). One function for BOTH places that tell the operator why a
 * unit failed, the blocking modal (`prepareUnitWithLadder`) and the card
 * panel, so the two can never disagree.
 *
 * Precedence: a broken shared-blank link wins. Its advice is "set it aside",
 * which must not be buried under the generic "tap Retry" or "print the film
 * from your RIP" lines. Within every other class the order is unchanged:
 * report failed, then no artwork attached, then healing, then filed.
 */
export interface EscalationCopyInput {
  /** The report itself failed: nobody has been told. */
  reportFailed: boolean;
  /** The customiser never attached a design (BLU-817). */
  noArtworkAttached: boolean;
  /** The backend also kicked its artwork re-fetch. */
  healTriggered: boolean;
  /** The garment's shared-blank link is broken (Phase 92). */
  supplyBlocked: boolean;
}

export function escalationCopyKeys(e: EscalationCopyInput): { titleKey: string; lineKey: string } {
  if (e.supplyBlocked) {
    return {
      titleKey: 'filmPrint.escalationSupplyBlockedTitle',
      lineKey: e.reportFailed
        ? 'filmPrint.escalationSupplyBlockedReportFailedLine'
        : 'filmPrint.escalationSupplyBlockedLine',
    };
  }
  return {
    titleKey: e.noArtworkAttached && !e.reportFailed
      ? 'filmPrint.escalationNoArtworkTitle'
      : 'filmPrint.escalationTitle',
    lineKey: e.reportFailed
      ? 'filmPrint.escalationReportFailedLine'
      : e.noArtworkAttached
        ? 'filmPrint.escalationNoArtworkLine'
        : e.healTriggered
          ? 'filmPrint.escalationHealingLine'
          : 'filmPrint.escalationFiledLine',
  };
}
